import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBrandheroWorkingOnComputerLigth = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 380 250",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_6479_16876)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M375.054 213.577C375.495 213.577 375.853 213.935 375.853 214.377V219.96C375.853 224.402 372.497 228.068 368.192 228.568V216.768C368.192 215.01 369.624 213.577 371.381 213.577H375.054ZM375.054 210.243H371.381C367.784 210.243 364.861 213.16 364.861 216.768V231.96H367.201C373.821 231.96 379.192 226.585 379.192 219.96V214.377C379.192 212.093 377.344 210.243 375.062 210.243H375.054Z",
				fill: "#001321"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M332.627 248.535C331.219 248.535 330.07 247.385 330.07 245.977V241.602H355.052V245.977C355.052 247.385 353.903 248.535 352.495 248.535H332.635H332.627Z",
				fill: "#83ce63"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M354.22 242.435V245.977C354.22 246.927 353.445 247.702 352.496 247.702H332.636C331.686 247.702 330.912 246.927 330.912 245.977V242.435H354.228M355.885 240.769H329.238V245.977C329.238 247.852 330.754 249.369 332.627 249.369H352.488C354.361 249.369 355.877 247.852 355.877 245.977V240.769H355.885Z",
				fill: "#001321"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M330.818 243.719C323.74 243.719 317.986 237.96 317.986 230.877V207.302C317.986 205.527 319.427 204.085 321.201 204.085H363.919C365.692 204.085 367.133 205.527 367.133 207.302V230.877C367.133 237.96 361.379 243.719 354.301 243.719H330.818Z",
				fill: "#83ce63"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M363.919 204.926C365.235 204.926 366.301 205.993 366.301 207.31V230.885C366.301 237.51 360.922 242.894 354.302 242.894H330.819C324.199 242.894 318.82 237.51 318.82 230.885V207.31C318.82 205.993 319.886 204.926 321.201 204.926H363.919ZM363.919 203.26H321.201C318.97 203.26 317.154 205.068 317.154 207.31V230.885C317.154 238.435 323.275 244.56 330.819 244.56H354.302C361.846 244.56 367.966 238.435 367.966 230.885V207.31C367.966 205.076 366.159 203.26 363.919 203.26Z",
				fill: "#001321"
			}),
			/* @__PURE__ */ _jsx("path", {
				opacity: .3,
				d: "M335.408 243.528C350.047 242.786 348.865 229.328 348.865 229.328V204.027H363.038C365.211 204.027 366.976 205.794 366.976 207.969V229.953C366.976 237.453 360.906 243.528 353.411 243.528H335.408Z",
				fill: "#001321"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M339.147 172.685C337.023 175.952 335.383 180.06 337.423 183.56C338.297 185.285 340.237 186.427 341.445 187.902C344.484 191.052 345.042 196.877 341.162 199.569C340.554 199.944 339.854 200.21 339.155 200.135C341.786 199.477 342.852 196.369 342.636 193.952C342.378 191.452 340.812 189.285 338.847 187.644C338.131 186.977 337.19 186.119 336.623 185.26C336.407 185.01 336.19 184.61 336.049 184.302C333.909 180.344 336.016 175.435 339.163 172.677L339.147 172.685Z",
				fill: "#001321"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M350.363 164.027C348.24 167.294 346.6 171.402 348.64 174.902C349.514 176.627 351.454 177.769 352.662 179.244C355.701 182.394 356.267 188.219 352.379 190.911C351.771 191.286 351.071 191.552 350.372 191.477C353.003 190.819 354.069 187.711 353.852 185.294C353.594 182.794 352.029 180.627 350.064 178.985C349.348 178.319 348.407 177.46 347.84 176.602C347.624 176.352 347.407 175.952 347.266 175.644C345.126 171.685 347.232 166.777 350.38 164.019L350.363 164.027Z",
				fill: "#001321"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M270.674 180.868C268.409 158.385 262.489 129.318 256.418 105.167C254.686 98.3089 252.954 91.9005 251.297 86.2004C245.302 65.5835 242.545 39.4498 223.826 25.7663C203.141 10.6411 169.208 12.8745 153.229 34.0081C141.895 48.9999 138.714 68.5668 133.568 86.2004C131.861 92.0505 130.087 98.6505 128.314 105.701C122.285 129.759 116.389 159.035 114.141 181.352L94.4141 189.085L109.619 246.902H194.173H189.826H274.38L289.585 189.085L270.716 181.327L270.666 180.868H270.674Z",
				fill: "#1c70e8",
				stroke: "#001321",
				strokeWidth: 3.36942,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M194.443 214.411C194.152 214.411 193.869 214.411 193.577 214.403C183.476 214.194 172.959 210.994 164.732 205.636C152.841 197.886 145.746 185.669 145.746 172.96C145.746 162.169 151.009 151.893 160.568 144.018C169.845 136.377 182.202 131.993 194.468 131.993C200.239 131.993 205.893 132.943 211.256 134.81C216.269 136.56 220.948 139.01 225.487 141.385C230.333 143.918 235.338 146.543 240.817 148.36C246.604 150.277 252.283 151.252 257.688 151.252C260.677 151.252 263.558 150.943 266.273 150.343C266.539 151.885 267.189 155.602 268.48 162.51C268.629 163.294 268.888 168.877 269.054 173.085C267.73 172.727 266.381 172.552 265.04 172.552C255.148 172.552 246.446 182.102 238.027 191.336C232.523 197.369 227.327 203.069 222.039 205.969C214.045 210.361 205.168 214.419 194.46 214.419L194.443 214.411Z",
				fill: "#D0DFFE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M194.461 132.827C200.14 132.827 205.694 133.761 210.974 135.602C215.928 137.327 220.583 139.769 225.088 142.127C229.959 144.678 234.997 147.311 240.543 149.153C246.414 151.103 252.176 152.086 257.672 152.086C260.412 152.086 263.06 151.836 265.583 151.336C265.916 153.228 266.549 156.794 267.648 162.661C267.756 163.278 267.981 167.569 268.164 172.02C267.123 171.811 266.074 171.711 265.025 171.711C254.766 171.711 245.931 181.395 237.396 190.761C231.941 196.745 226.795 202.395 221.624 205.228C213.722 209.562 204.961 213.578 194.444 213.578C194.161 213.578 193.878 213.578 193.595 213.57C183.644 213.362 173.285 210.22 165.183 204.937C153.533 197.345 146.58 185.386 146.58 172.953C146.58 162.419 151.734 152.369 161.103 144.653C170.229 137.136 182.395 132.819 194.469 132.819M194.461 131.161C168.73 131.161 144.906 149.794 144.906 172.953C144.906 185.953 152.151 198.437 164.267 206.328C172.511 211.703 183.153 215.02 193.553 215.228C193.853 215.228 194.145 215.237 194.436 215.237C204.862 215.237 213.772 211.428 222.415 206.687C236.055 199.203 249.228 173.37 265.017 173.37C266.616 173.37 268.248 173.636 269.913 174.211C269.913 174.211 269.513 163.569 269.28 162.344C267.473 152.661 266.924 149.319 266.924 149.319C263.909 150.078 260.795 150.411 257.664 150.411C252.026 150.411 246.331 149.311 241.06 147.561C230.509 144.061 221.924 137.652 211.515 134.019C205.886 132.061 200.123 131.152 194.453 131.152L194.461 131.161Z",
				fill: "#001321"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M193.847 117.66C188.384 117.66 183.038 116.785 177.959 115.051C173.212 113.435 168.774 111.168 164.477 108.976C159.889 106.635 155.142 104.21 149.946 102.526C144.45 100.751 139.071 99.8513 133.958 99.8513C132.842 99.8513 131.735 99.893 130.652 99.9846L141.877 59.4258C151.295 57.9258 160.155 53.4757 167.75 49.409C175.336 45.3506 183.746 41.6006 193.864 41.6006C194.138 41.6006 194.413 41.6006 194.696 41.6089C204.264 41.8006 214.215 44.759 222.009 49.709C233.251 56.8591 239.971 68.1259 239.971 79.8594C239.971 89.8095 234.991 99.2846 225.948 106.551C217.163 113.61 205.463 117.66 193.855 117.66H193.847Z",
				fill: "#D0DFFE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M193.865 40.7676V42.4343C194.131 42.4343 194.406 42.4343 194.681 42.4426C204.099 42.6343 213.9 45.5426 221.569 50.4177C232.569 57.4094 239.139 68.4179 239.139 79.8597C239.139 89.5515 234.268 98.8016 225.433 105.902C216.798 112.843 205.289 116.827 193.856 116.827C188.477 116.827 183.223 115.968 178.226 114.268C173.538 112.677 169.125 110.418 164.853 108.243C160.231 105.885 155.46 103.443 150.206 101.743C144.626 99.9433 139.155 99.0266 133.959 99.0266C133.227 99.0266 132.494 99.0433 131.769 99.085L142.536 60.1678C151.879 58.5678 160.631 54.1761 168.142 50.151C175.628 46.1426 183.93 42.4426 193.865 42.4426V40.7759M193.865 40.7676C183.989 40.7676 175.553 44.2926 167.359 48.676C158.866 53.2261 150.347 57.3428 141.221 58.6845L129.529 100.935C130.995 100.768 132.477 100.693 133.959 100.693C139.297 100.693 144.693 101.71 149.698 103.327C159.69 106.56 167.826 112.485 177.693 115.843C183.023 117.66 188.485 118.494 193.856 118.494C218.238 118.494 240.805 101.268 240.805 79.8597C240.805 67.8429 233.943 56.3094 222.46 49.0093C214.649 44.0426 204.573 40.9759 194.714 40.7759C194.431 40.7759 194.148 40.7676 193.865 40.7676Z",
				fill: "#001321"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M217.78 22.1169C213.3 19.7336 208.545 18.1169 203.591 17.2252C198.653 16.1335 193.173 15.8919 188.518 13.5252C185.362 11.9085 182.415 9.30011 181.141 5.92507L181.415 5.7334C182.806 6.80841 184.138 7.72509 185.537 8.51677C191.3 11.4418 197.87 13.3668 204.123 15.0752C209.061 16.5169 213.858 18.7836 217.972 21.8419L217.797 22.1253L217.78 22.1169Z",
				fill: "#001321"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M168.848 88.126C177.582 88.126 184.662 81.0408 184.662 72.3008C184.662 63.5608 177.582 56.4756 168.848 56.4756C160.115 56.4756 153.035 63.5608 153.035 72.3008C153.035 81.0408 160.115 88.126 168.848 88.126Z",
				fill: "white",
				stroke: "#001321",
				strokeWidth: 1.68471,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M168.599 88.1174C175.35 88.1174 180.823 82.6402 180.823 75.8839C180.823 69.1275 175.35 63.6504 168.599 63.6504C161.848 63.6504 156.375 69.1275 156.375 75.8839C156.375 82.6402 161.848 88.1174 168.599 88.1174Z",
				fill: "#001321"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M179.398 70.9917C180.341 70.0479 179.737 67.9136 178.049 66.2245C176.361 64.5355 174.229 63.9313 173.286 64.8751C172.343 65.8189 172.946 67.9532 174.634 69.6423C176.322 71.3313 178.455 71.9354 179.398 70.9917Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M216.407 88.126C225.14 88.126 232.22 81.0408 232.22 72.3008C232.22 63.5608 225.14 56.4756 216.407 56.4756C207.674 56.4756 200.594 63.5608 200.594 72.3008C200.594 81.0408 207.674 88.126 216.407 88.126Z",
				fill: "white",
				stroke: "#001321",
				strokeWidth: 1.68471,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M216.404 88.1174C223.155 88.1174 228.628 82.6402 228.628 75.8839C228.628 69.1275 223.155 63.6504 216.404 63.6504C209.653 63.6504 204.18 69.1275 204.18 75.8839C204.18 82.6402 209.653 88.1174 216.404 88.1174Z",
				fill: "#001321"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M227.206 67.4089C226.265 68.3506 224.125 67.7506 222.434 66.0589C220.744 64.3672 220.144 62.2338 221.085 61.2838C222.026 60.3422 224.166 64.5255 225.857 66.2172C227.547 67.9089 228.147 66.4589 227.206 67.4006V67.4089Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M225.824 34.3823L212.85 37.6824C210.977 38.1574 209.078 37.3657 208.245 35.7657L206.713 32.8156C206.205 31.8323 207.129 30.649 208.279 30.8156L225.824 33.4073C226.373 33.4907 226.373 34.2407 225.824 34.3823Z",
				fill: "#001321"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M159.432 34.3823L172.405 37.6824C174.279 38.1574 176.178 37.3657 177.01 35.7657L178.542 32.8156C179.05 31.8323 178.126 30.649 176.977 30.8156L159.432 33.4073C158.882 33.4907 158.882 34.2407 159.432 34.3823Z",
				fill: "#001321"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0 248.402C121.867 246.161 246.241 246.219 368.126 248.152L380 248.402L368.126 248.652C246.233 250.577 121.876 250.636 0 248.402Z",
				fill: "#001321"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M278.657 247.293C277.349 247.293 276.05 247.126 274.793 246.81C269.33 245.41 264.925 241.11 262.386 234.701C259.771 228.109 259.454 220.126 261.478 212.226C265.1 198.101 275.384 187.851 285.926 187.851C287.234 187.851 288.533 188.017 289.79 188.334C295.253 189.734 299.658 194.034 302.198 200.442C304.812 207.034 305.129 215.018 303.105 222.918C299.483 237.043 289.199 247.293 278.657 247.293Z",
				fill: "#D0DFFE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M285.936 189.51C287.102 189.51 288.268 189.66 289.384 189.943C294.313 191.21 298.319 195.16 300.659 201.052C303.14 207.319 303.44 214.935 301.5 222.494C299.793 229.152 296.445 235.161 292.082 239.402C287.968 243.411 283.205 245.611 278.667 245.611C277.501 245.611 276.335 245.461 275.219 245.177C270.29 243.911 266.284 239.961 263.944 234.069C261.463 227.802 261.163 220.186 263.103 212.627C264.81 205.969 268.158 199.96 272.521 195.719C276.635 191.71 281.398 189.51 285.936 189.51ZM285.936 186.177C274.845 186.177 263.745 196.71 259.872 211.802C255.501 228.844 261.996 245.236 274.378 248.419C275.794 248.786 277.226 248.961 278.658 248.961C289.75 248.961 300.85 238.427 304.722 223.336C309.094 206.294 302.599 189.902 290.216 186.718C288.801 186.352 287.369 186.177 285.936 186.177Z",
				fill: "#001321"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M264.404 140.851C264.404 140.851 274.188 179.659 246.667 221.518C219.146 263.377 203.491 217.468 222.111 199.643C240.73 181.818 240.047 142.667 240.047 142.667",
				fill: "#1c70e8"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M264.404 140.851C264.404 140.851 274.188 179.659 246.667 221.518C219.146 263.377 203.491 217.468 222.111 199.643C240.73 181.818 240.047 142.667 240.047 142.667",
				stroke: "#001321",
				strokeWidth: 3.36942,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M120.559 140.851C120.559 140.851 110.774 179.659 138.296 221.518C165.817 263.377 181.472 217.468 162.852 199.643C144.233 181.818 144.916 142.667 144.916 142.667",
				fill: "#1c70e8"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M120.559 140.851C120.559 140.851 110.774 179.659 138.296 221.518C165.817 263.377 181.472 217.468 162.852 199.643C144.233 181.818 144.916 142.667 144.916 142.667",
				stroke: "#001321",
				strokeWidth: 3.36942,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				opacity: .3,
				d: "M163.629 215.369C154.311 205.102 147.217 192.835 143.519 179.452C142.587 176.068 141.896 172.593 141.071 169.177C135.842 146.985 138.381 113.843 144.419 92.3008C147.816 80.1756 151.622 67.9005 155.435 55.842C160.673 39.2835 169.192 23.1916 186.162 16.5332C173.83 18.2082 162.197 23.975 154.611 34.0084C143.278 49.0086 140.097 68.5755 134.951 86.2007C133.244 92.0508 131.47 98.6509 129.696 105.701C123.667 129.76 115.598 157.602 113.35 179.919C112.917 184.21 102.933 183.21 102.791 186.902C102.733 188.435 110.902 190.327 110.078 193.435C108.62 198.969 113.866 212.402 113.875 212.686C113.875 213.544 123.642 217.627 123.676 218.427C124.692 244.869 109.253 248.419 109.253 248.419L115.873 248.403L188.452 246.903H193.807C193.807 246.903 216.965 247.228 216.973 247.228C212.668 247.703 195.381 238.644 191.633 236.753C181.15 231.461 171.565 224.144 163.604 215.369H163.629Z",
				fill: "#001321"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M260.015 238.086H124.841C124.064 238.086 123.434 238.716 123.434 239.494V246.578C123.434 247.356 124.064 247.986 124.841 247.986H260.015C260.792 247.986 261.422 247.356 261.422 246.578V239.494C261.422 238.716 260.792 238.086 260.015 238.086Z",
				fill: "white",
				stroke: "#001321",
				strokeWidth: 1.68471,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M105.336 247.295C94.7943 247.295 84.5103 237.045 80.888 222.92C78.8645 215.02 79.181 207.036 81.7957 200.444C84.3355 194.036 88.7405 189.736 94.2031 188.336C95.4605 188.011 96.7595 187.853 98.0669 187.853C108.609 187.853 118.893 198.103 122.515 212.228C124.539 220.128 124.222 228.111 121.608 234.703C119.068 241.112 114.663 245.412 109.2 246.812C107.943 247.137 106.644 247.295 105.336 247.295Z",
				fill: "#D0DFFE"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M98.0686 186.178V189.512C102.607 189.512 107.37 191.72 111.484 195.72C115.847 199.97 119.195 205.978 120.902 212.629C122.842 220.195 122.542 227.804 120.061 234.071C117.721 239.971 113.724 243.912 108.794 245.179C107.67 245.471 106.512 245.612 105.347 245.612C100.808 245.612 96.0451 243.404 91.9315 239.404C87.5681 235.154 84.2206 229.145 82.5135 222.495C78.6081 207.262 84.0374 192.662 94.6212 189.937C95.7453 189.645 96.9028 189.503 98.0686 189.503V186.17M98.0686 186.178C96.6363 186.178 95.2041 186.353 93.7885 186.72C81.406 189.903 74.9109 206.295 79.2826 223.337C83.1547 238.429 94.2548 248.962 105.347 248.962C106.779 248.962 108.211 248.787 109.627 248.421C122.009 245.237 128.504 228.845 124.133 211.804C120.26 196.712 109.16 186.178 98.0686 186.178Z",
				fill: "#001321"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M248.14 170.26H136.723V247.986H248.14V170.26Z",
				fill: "white",
				stroke: "#001321",
				strokeWidth: 3.36942,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M177.176 199.66C177.176 197.077 179.266 194.977 181.839 194.977H189.608C190.158 194.977 190.682 195.068 191.165 195.243C193.514 196.077 195.67 198.093 198.152 198.093C200.633 198.093 202.798 196.077 205.138 195.243C205.63 195.068 206.154 194.977 206.695 194.977C209.269 194.977 211.359 197.077 211.359 199.66C211.359 202.243 209.269 204.343 206.695 204.343C206.146 204.343 205.621 204.252 205.138 204.077C202.79 203.243 200.633 201.227 198.152 201.227C195.67 201.227 193.505 203.243 191.165 204.077C190.674 204.252 190.149 204.343 189.608 204.343H181.839C179.266 204.343 177.176 202.243 177.176 199.66ZM177.176 212.152C177.176 209.568 179.266 207.468 181.839 207.468C182.522 207.468 183.171 207.618 183.763 207.885C185.819 208.818 187.751 210.593 190 210.593C192.248 210.593 194.188 208.818 196.237 207.885C196.819 207.618 197.469 207.468 198.16 207.468C200.733 207.468 202.823 209.568 202.823 212.152C202.823 214.735 200.733 216.835 198.16 216.835C197.477 216.835 196.828 216.685 196.237 216.419C194.18 215.485 192.248 213.71 190 213.71C187.751 213.71 185.811 215.485 183.763 216.419C183.18 216.685 182.53 216.835 181.839 216.835C179.266 216.835 177.176 214.735 177.176 212.152ZM181.839 219.96C179.266 219.96 177.176 222.06 177.176 224.644C177.176 227.227 179.266 229.327 181.839 229.327C184.412 229.327 186.502 227.227 186.502 224.644C186.502 222.06 184.412 219.96 181.839 219.96Z",
				fill: "#1c70e8"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M351.905 1.5498H261.63C258.669 1.5498 256.268 3.95257 256.268 6.91654V66.9256C256.268 69.8896 258.669 72.2923 261.63 72.2923H351.905C354.866 72.2923 357.267 69.8896 357.267 66.9256V6.91654C357.267 3.95257 354.866 1.5498 351.905 1.5498Z",
				stroke: "#001321",
				strokeWidth: 1.68471,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M261.631 1.5498H351.897C354.861 1.5498 357.259 3.95817 357.259 6.91654V12.2833H256.26V6.91654C256.26 3.94983 258.666 1.5498 261.622 1.5498H261.631Z",
				fill: "#1c70e8",
				stroke: "#001321",
				strokeWidth: 1.68471,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M263.662 9.23293C264.936 9.23293 265.969 8.19945 265.969 6.92457C265.969 5.6497 264.936 4.61621 263.662 4.61621C262.388 4.61621 261.355 5.6497 261.355 6.92457C261.355 8.19945 262.388 9.23293 263.662 9.23293Z",
				fill: "#001321"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M122.174 36.6177C123.448 36.6177 124.48 35.5842 124.48 34.3093C124.48 33.0345 123.448 32.001 122.174 32.001C120.9 32.001 119.867 33.0345 119.867 34.3093C119.867 35.5842 120.9 36.6177 122.174 36.6177Z",
				fill: "#001321"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M342.561 156.285C343.834 156.285 344.867 155.251 344.867 153.976C344.867 152.701 343.834 151.668 342.561 151.668C341.287 151.668 340.254 152.701 340.254 153.976C340.254 155.251 341.287 156.285 342.561 156.285Z",
				fill: "#001321"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M44.3164 197.285C45.5903 197.285 46.623 196.251 46.623 194.976C46.623 193.701 45.5903 192.668 44.3164 192.668C43.0425 192.668 42.0098 193.701 42.0098 194.976C42.0098 196.251 43.0425 197.285 44.3164 197.285Z",
				fill: "#001321"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M273.164 9.23293C274.438 9.23293 275.471 8.19945 275.471 6.92457C275.471 5.6497 274.438 4.61621 273.164 4.61621C271.89 4.61621 270.857 5.6497 270.857 6.92457C270.857 8.19945 271.89 9.23293 273.164 9.23293Z",
				fill: "#001321"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M282.264 9.23293C283.538 9.23293 284.57 8.19945 284.57 6.92457C284.57 5.6497 283.538 4.61621 282.264 4.61621C280.99 4.61621 279.957 5.6497 279.957 6.92457C279.957 8.19945 280.99 9.23293 282.264 9.23293Z",
				fill: "#001321"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M362.155 120.551C368.396 120.551 373.455 115.488 373.455 109.242C373.455 102.997 368.396 97.9336 362.155 97.9336C355.915 97.9336 350.855 102.997 350.855 109.242C350.855 115.488 355.915 120.551 362.155 120.551Z",
				stroke: "#001321",
				strokeWidth: 1.68471,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M44.3175 115.276C50.5583 115.276 55.6174 110.213 55.6174 103.968C55.6174 97.7222 50.5583 92.6592 44.3175 92.6592C38.0767 92.6592 33.0176 97.7222 33.0176 103.968C33.0176 110.213 38.0767 115.276 44.3175 115.276Z",
				stroke: "#001321",
				strokeWidth: 1.68471,
				strokeMiterlimit: 10
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M314.696 98.7676H292.854V120.626H314.696V98.7676Z",
				fill: "#83ce63"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M313.864 99.6013V119.793H293.687V99.6013H313.864ZM315.529 97.9346H292.021V121.46H315.529V97.9346Z",
				fill: "#001321"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M93.7639 112.46H71.9219V134.319H93.7639V112.46Z",
				fill: "#83ce63"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M92.9319 113.294V133.486H72.7553V113.294H92.9319ZM94.5973 111.627H71.0898V135.152H94.5973V111.627Z",
				fill: "#001321"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M320.438 109.692H347.034",
				stroke: "#001321",
				strokeWidth: 1.68471,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M273.162 75.8828V149.184",
				stroke: "#001321",
				strokeWidth: 1.68471,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M303.781 149.777H273.162",
				stroke: "#001321",
				strokeWidth: 1.68471,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M335.748 153.976H305.129",
				stroke: "#001321",
				strokeWidth: 1.68471,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M303.781 127.159V177.751",
				stroke: "#001321",
				strokeWidth: 1.68471,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M256.268 177.752H303.782",
				stroke: "#001321",
				strokeWidth: 1.68471,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M131.903 177.752H82.8477",
				stroke: "#001321",
				strokeWidth: 1.68471,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M82.8477 140.851V177.751",
				stroke: "#001321",
				strokeWidth: 1.68471,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M44.1094 157.401H82.8472",
				stroke: "#001321",
				strokeWidth: 1.68471,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M83.4375 56.4756H122.175",
				stroke: "#001321",
				strokeWidth: 1.68471,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M44.3164 184.552V123.393",
				stroke: "#001321",
				strokeWidth: 1.68471,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M82.8477 106.467V40.7666",
				stroke: "#001321",
				strokeWidth: 1.68471,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M122.176 56.4751V40.7666",
				stroke: "#001321",
				strokeWidth: 1.68471,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M42.6004 98.7422L37.4043 103.942L42.6421 109.184",
				stroke: "#001321",
				strokeWidth: 1.68471,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M45.9836 98.7422L51.1797 103.942L45.9336 109.184",
				stroke: "#001321",
				strokeWidth: 1.68471,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M83.7948 23.0833C87.5292 23.0833 90.5565 20.0537 90.5565 16.3166C90.5565 12.5794 87.5292 9.5498 83.7948 9.5498C80.0605 9.5498 77.0332 12.5794 77.0332 16.3166C77.0332 20.0537 80.0605 23.0833 83.7948 23.0833Z",
				stroke: "#001321",
				strokeWidth: 1.68471,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M81.1066 32.2417L79.2663 26.0333L73.837 28.8667L70.5395 25.8L74.27 20.4416L67.9414 18.8332V13.9332L74.27 11.9415L71.1557 7.49142L74.27 4.43305L79.3412 7.11642L81.1066 0.833008H85.7698L87.5351 7.11642L92.6147 4.43305L95.7207 7.49142L92.6147 11.9415L98.935 13.9332V18.8332L92.6147 20.4416L96.3369 25.8L93.0477 28.8667L87.6101 26.0333L85.7698 32.2417H81.1066Z",
				stroke: "#001321",
				strokeWidth: 1.68471,
				strokeMiterlimit: 10,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M204.309 95.209C202.835 101.951 198.646 106.917 193.333 107.351C188.029 107.784 183.091 103.559 180.543 97.1423C183.915 99.1674 188.187 100.209 192.726 99.8424C197.264 99.4757 201.311 97.759 204.309 95.209Z",
				fill: "white",
				stroke: "#001321",
				strokeWidth: 2.52706,
				strokeMiterlimit: 10
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_6479_16876",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 380,
			height: 250,
			fill: "white"
		})
	}) })]
});
export default SvgBrandheroWorkingOnComputerLigth;
